import { Link } from "react-router";
import { EmptyState } from "@/components/ui/States";

export function NotFoundPage() {
  return (
    <EmptyState
      title="Không tìm thấy trang"
      description="Đường dẫn không tồn tại hoặc đã được đổi."
      action={
        <Link to="/" className="text-sm font-medium text-accent-text hover:underline">
          Về trang tổng quan
        </Link>
      }
    />
  );
}
